import { ReactElement } from "react";
import { Router, Route, Switch } from "_/components/router";

import { publicRoutes } from "_/routes";

import { Private } from "_/components/private";
import { Public } from "_/components/public";
import { Headless } from "_/components/headless";
import { BootstrapView } from "_/components/bootstrap";
import { Header } from "_/components/header";
import { Toasts } from "_/components/toasts";
import { LoginView } from "_/components/login-view";

const headerlessRoutes: string[] = [
  publicRoutes.headless,
  publicRoutes.login,
  publicRoutes.bootstrap,
];

const HeaderRoutes = (): ReactElement => (
  <>
    <Header />
    <Switch>
      {Object.values(publicRoutes)
        .filter((route) => !headerlessRoutes.includes(route))
        .map((route) => (
          <Route key={route} path={route} component={Public} />
        ))}
      <Route component={Private} />
    </Switch>
  </>
);

// Main app component.
//
// This component includes providers and the top level wrapper components that
// act as providers for children, or otherwise add functionality on the global
// scope.
export const App = (): ReactElement => {
  return (
    <Router>
      <Switch>
        <Route path={publicRoutes.headless} component={Headless} />
        <Route path={publicRoutes.login} component={LoginView} />
        <Route path={publicRoutes.bootstrap} component={BootstrapView} />
        <Route component={HeaderRoutes} />
      </Switch>
      <Toasts />
    </Router>
  );
};
